import '@wangeditor/editor/dist/css/style.css' // 引入 css
import React, { useState, useEffect, useMemo } from 'react';
import { CloseOutlined, PlusOutlined, } from '@ant-design/icons';
import { Button, Card, Form, Input, Space, ColorPicker, Image, Upload, Divider, message, Breadcrumb } from 'antd';
import { useSearchParams } from 'react-router-dom';
import { request } from '@/utils'


const M2d6 = () => {



    const [messageApi, contextHolder] = message.useMessage();
    const token = localStorage.getItem('token_key')

    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [fileList, setFileList] = useState([]);

    // const colornr='#1677ff';
    const [urlp] = useSearchParams()
    const [form] = Form.useForm();


    const [color, setColor] = useState('#1677ff');
    const bgColor = useMemo(() => {
        return typeof color === 'string' ? color : color.toHexString()
    }, [color]);
    const btnStyle = {
        backgroundColor: bgColor,
    };




    useEffect(() => {
        async function getau() {
            const res = await request.post('/pms_style1_c', { pno: urlp.get('q') })
             const formmsg = res.json.style1_json
           console.log(formmsg)
             res.json && form.setFieldsValue(formmsg)//设置默认颜色 && pno
            form.setFieldValue('pno', urlp.get('q'))
             formmsg.mcv && setColor(formmsg.mcv)



            formmsg.imgjson && setFileList(formmsg.imgjson)
            formmsg.imgjson && form.setFieldValue('imgjson', formmsg.imgjson)



        }

        getau()

    }, [urlp, form])
    //更新颜色
    useEffect(() => { form.setFieldValue('mcv', typeof color === 'string' ? color : color.toHexString()) }, [color, form])

    const onFinish = async (values) => {
        console.log(JSON.stringify(values))
        const resc = await request.post('/pms_style1_u', values)
        messageApi.open({
            type: resc.return_code,
            content: resc.return_msg,
        });

    }




    const onRemove = async (e) => {
        await request.post('/p_upfile_d', e)
        form.setFieldValue('imgjson', fileList)// 更新imgjson

    }


    const handleChange = ({ fileList: newFileList }) => {

        if (newFileList[0] !== undefined && newFileList[0].status === 'done') {

            newFileList = newFileList.map((file) => {


                if (file.response) {
                    if (file.response.return_code === 'success') {
                        file.uid = file.response.fbody[0].uid;
                        file.name = file.response.fbody[0].name;
                        file.status = file.response.fbody[0].status;
                        file.url = file.response.fbody[0].url;

                        //response
                    }
                    if (file.response.return_code === 'F') { file.status = "" }
                    //这里可以更新
                }
                delete file.response;
                delete file.originFileObj;
                delete file.lastModified;
                delete file.lastModifiedDate;
                delete file.percent;
                delete file.size;
                delete file.xhr;
                return file;
            });
        }

        setFileList(newFileList)
        form.setFieldValue('imgjson', newFileList)
    }
    const uploadButton = (
        <button
            style={{
                border: 0,
                background: 'none',
            }}
            type="button"
        >
            <PlusOutlined />
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Upload
            </div>
        </button>
    );

    const props = {
        action: 'http://api.ddspp.com:30123/v3/p_upfile',
        onChange: handleChange,
        fileList: fileList,
        showUploadList: true,
        listType: 'picture-card',
        headers: { Authorization: `{"Bearer_ddspp":"${token}"}` },
        onRemove: onRemove
    };




    return (<>{contextHolder}

        <Breadcrumb
            items={[
                {
                    title: '基础数据',
                },
                {
                    title: '基本参数',
                },

            ]}
        />
        <Form
            name='form'
            labelCol={{
                span: 6,
            }}
            wrapperCol={{
                span: 18,
            }}
            onFinish={onFinish}
            form={form}

            style={{
                maxWidth: 1000,
                marginTop:'10px'
            }}
            autoComplete="off"
            initialValues={{
                mjson: [{}],
            }}
        >

            <Upload
                {...props}
            >
                {fileList.length >= 5 ? null : uploadButton}
            </Upload>
            {previewImage && (
                <Image
                    wrapperStyle={{
                        display: 'none',
                    }}
                    preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => setPreviewOpen(visible),
                        afterOpenChange: (visible) => !visible && setPreviewImage(''),
                    }}
                    src={previewImage}
                />
            )}


            <Divider />



            <Form.Item
                hidden={true}
                name='imgjson'  >
                <Input />
            </Form.Item>
            <Form.Item
                hidden={true}
                name='mcv'  >
                <Input />
            </Form.Item>
            <Form.Item
                hidden={true}
                name='pno'  >
                <Input />
            </Form.Item>


            <Form.List name="mjson" >



                {(fields, { add, remove }) => (


                    <div
                        style={{
                            display: 'flex',
                            rowGap: 16,
                            flexDirection: 'column',
                        }}
                    >

                        {/* <Form.Item label="主题颜色" > */}
                        <Space>

                            <ColorPicker
                                allowClear
                                showText
                                value={color} onChange={setColor}

                            >
                                <Button type="primary"
                                    style={btnStyle}
                                >
                                    主体颜色
                                </Button> </ColorPicker>
                            <Button type="dashed" onClick={() => add()} >
                                + 添加模块
                            </Button>






                        </Space>




                        {fields.map((field) => (
                            <Card
                                size="small"
                                title={`模块 ${field.name + 1}`}
                                key={field.key}
                                extra={
                                    <CloseOutlined
                                        onClick={() => {
                                            remove(field.name);
                                        }}
                                    />
                                }
                            >

                                <Form.Item label="模块名称" name={[field.name, 'mname']} >
                                    <Input count={{ show: true, }} />
                                </Form.Item>



                                {/* Nest Form.List */}
                                <Form.Item label="子项信息">
                                    <Form.List name={[field.name, 'list']}>
                                        {(subFields, subOpt) => (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    rowGap: 16,
                                                }}
                                            >
                                                {subFields.map((subField) => (
                                                    <Space key={subField.key}>
                                                        <Form.Item noStyle name={[subField.name, 'first']}>
                                                            <Input placeholder="类目名称" />
                                                        </Form.Item>
                                                        <Form.Item noStyle name={[subField.name, 'second']}>
                                                            <Input placeholder="内容" />
                                                        </Form.Item>
                                                        <CloseOutlined
                                                            onClick={() => {
                                                                subOpt.remove(subField.name);
                                                            }}
                                                        />
                                                    </Space>
                                                ))}
                                                <Button type="dashed" onClick={() => subOpt.add()} >
                                                    + 添加子项目
                                                </Button>
                                            </div>
                                        )}
                                    </Form.List>
                                </Form.Item>
                            </Card>
                        ))}






                    </div>





                )}


            </Form.List>
            <Divider />

            <Form.Item > <Button type="primary"
                htmlType="submit"
                block
            >
                提   交
            </Button>


            </Form.Item>







        </Form>

    </>

    );
};
export default M2d6